module.exports = __webpack_public_path__ + "img/visible.07731061.svg";